// extracted by mini-css-extract-plugin
module.exports = {"container":"ColorContrast_container__3KJ2R"};